import { AcceptInvitationCard, AuthShell, useAuth } from "@nexys/user-management-web";
import { Navigate, useNavigate, useParams } from "react-router-dom";

/**
 * Landing page for the emailed invitation link:
 * /accept-invitation/:id. The server only accepts the invitation for
 * the signed-in user whose email matches, so unauthenticated visitors
 * are bounced to sign-in (and back here afterwards).
 */
export const AcceptInvitationPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  if (!id) return <Navigate to="/" replace />;

  return (
    <AuthShell brand="UM-RS Console">
      <AcceptInvitationCard
        invitationId={id}
        onAccepted={async () => {
          // Pick up the re-minted active-tenant cookie, then land home.
          await refresh();
          navigate("/", { replace: true });
        }}
      />
    </AuthShell>
  );
};
